export default {
  title_issue: "Remove Issue from Work Order",
  title_item: "Remove Item from Work Order",
  content_issue:
    "Are you sure you want to remove the <b class='text-info'>Issue</b> from this <b class='text-info'>Work Order</b>?",
  content_item:
    "Are you sure you want to remove this <b class='text-info'>Item</b> from the <b class='text-info'>Work Order</b>?",
  checkbox_label: "Don’t ask again.",
}
